import React from 'react'

const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.098 9.33333H10.4313V4.66667C10.4313 4.30222 10.1291 4 9.76465 4C9.4002 4 9.09798 4.30222 9.09798 4.66667V9.33333H4.43132C4.06687 9.33333 3.76465 9.63556 3.76465 10C3.76465 10.3644 4.06687 10.6667 4.43132 10.6667H9.09798V15.3333C9.09798 15.6978 9.4002 16 9.76465 16C10.1291 16 10.4313 15.6978 10.4313 15.3333V10.6667H15.098C15.4624 10.6667 15.7646 10.3644 15.7646 10C15.7646 9.63556 15.4624 9.33333 15.098 9.33333Z" fill="#6B7073"/>
</svg>
)

export default Plus;
